module.exports = __webpack_public_path__ + "static/media/check-mark.c1038f27.svg";